export default function pluralize(word: string, amount: number = 0) {
	if (!word) return word
	return (amount > 1 || amount === 0) ? `${word}s` : word

}
